/**
 * @generated SignedSource<<a0de8cd10706b3897dd33a59770455bc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ResultBuyingCreditsOperation = "FAILED" | "SUCCESS" | "SUCCESS_FOR_TRIAL" | "WAITING_FOR_APPROVAL";
export type ServicesWithCredits = "AI_STUDIO" | "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_SIDE_GENERATOR" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO" | "GENERATIVE_AI" | "GENERATIVE_AI_DESIGN" | "GENERATIVE_AI_IMAGE_GENERATOR" | "GENERATIVE_AI_PRODUCT_STAGING" | "GENERATIVE_AI_VTO" | "TEST_ORDERS" | "VECTORIZE";
export type ServiceRechargeCreditsInput = {
  autoRefill: boolean;
  credits: number;
  currencyCode: string;
  expirationDate?: string | null;
  isForTrial?: boolean | null;
  isForTrialOnFirstPackage?: boolean | null;
  returnUrlFromApproval?: string | null;
  service: ServicesWithCredits;
  shopifyChargeID?: string | null;
};
export type serviceCreditsBuyServiceCreditsMutation$variables = {
  input: ServiceRechargeCreditsInput;
};
export type serviceCreditsBuyServiceCreditsMutation$data = {
  readonly buyServiceCredits: {
    readonly errorMessage: string | null;
    readonly result: ResultBuyingCreditsOperation;
    readonly urlForApproval: string | null;
  } | null;
};
export type serviceCreditsBuyServiceCreditsMutation = {
  response: serviceCreditsBuyServiceCreditsMutation$data;
  variables: serviceCreditsBuyServiceCreditsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ServiceBuyingResultOperation",
    "kind": "LinkedField",
    "name": "buyServiceCredits",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlForApproval",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "serviceCreditsBuyServiceCreditsMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "serviceCreditsBuyServiceCreditsMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "4e922b0a0dcca3268de29bd74df6fb15",
    "id": null,
    "metadata": {},
    "name": "serviceCreditsBuyServiceCreditsMutation",
    "operationKind": "mutation",
    "text": "mutation serviceCreditsBuyServiceCreditsMutation(\n  $input: ServiceRechargeCreditsInput!\n) {\n  buyServiceCredits(input: $input) {\n    errorMessage\n    result\n    urlForApproval\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a86ba6eb84897188d0205413d7b19e6";

export default node;
